import { render, staticRenderFns } from "./HomePlans.vue?vue&type=template&id=50430e32&scoped=true&"
import script from "./HomePlans.vue?vue&type=script&lang=js&"
export * from "./HomePlans.vue?vue&type=script&lang=js&"
import style0 from "./HomePlans.vue?vue&type=style&index=0&id=50430e32&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50430e32",
  null
  
)

component.options.__file = "HomePlans.vue"
export default component.exports